import { useEffect, useState } from "react"

import { toast } from "react-toastify"
import { finalize } from "rxjs/operators"

import NotificationOptions from "./NotificationOptions"
import NotificationOptionsData from "../../../api/Notifications/Model/NotificationOptionsData"
import NotificationSectionProps from "../../../api/Notifications/Model/NotificationSectionProps"
import { NotificationEventsGet } from "../../../api/Notifications/NotificationDetailGet"
import FormatError from "../../../formatters/FormatError"

interface NotificationEventSelectionProps extends NotificationSectionProps {
  canViewOrderTrackingGrid?: boolean
}

function NotificationEventSelection(props: NotificationEventSelectionProps) {
  const { selectedIDs, canViewOrderTrackingGrid, onChange } = props

  const [loading, setLoading] = useState(false)
  const [notificationEvents, setNotificationEvents] = useState<NotificationOptionsData[]>([])

  useEffect(() => {
    setLoading(true)
    const subscription = NotificationEventsGet()
      .pipe(finalize(() => setLoading(false)))
      .subscribe(
        (data) => {
          setNotificationEvents(
            data
              .filter((event) => !(!canViewOrderTrackingGrid && event.Title === "MRO_RES"))
              .map((event) => ({ Id: event.NotificationEventID, Code: event.Title, Description: event.Description }))
          )
        },
        (error) => toast.error(FormatError(error))
      )
    return () => subscription?.unsubscribe()
  }, [canViewOrderTrackingGrid])

  return (
    <NotificationOptions
      items={notificationEvents}
      selectedIDs={selectedIDs}
      loading={loading}
      onChange={onChange}
      description="Status Updates"
    />
  )
}

NotificationEventSelection.defaultProps = {
  canViewOrderTrackingGrid: false,
}

export default NotificationEventSelection
